import { EMPTY_PROFILE, STORAGE_PROFILE } from "../constants";
import { TProfileData } from "../types";

export function getListenerIdent(): TProfileData | null {
  try {
    const raw = localStorage.getItem(STORAGE_PROFILE);
    return raw ? (JSON.parse(raw) as TProfileData) : null;
  } catch {
    return null;
  }
}

export const loadProfile = (): TProfileData => ({
  ...EMPTY_PROFILE,
  ...getListenerIdent(),
});

export const saveProfileData = (data: TProfileData) => {
  try {
    localStorage.setItem(STORAGE_PROFILE, JSON.stringify(data));
    return true;
  } catch (e) {
    console.error("Не удалось сохранить в localStorage", e);
    return false;
  }
};

export const isListenerFilled = () => {
  const d = getListenerIdent();
  return !!d && d.username.trim() !== "" && d.username.trim() !== "";
};

export const shouldShowListenerIdentAlert = () => {
  const d = getListenerIdent();
  return d?.skip && d.skip === true && !isListenerFilled() ? true : false;
};

export const shouldAutoOpenListenerIdent = () => !getListenerIdent();
